export enum NaturaGiuridicaEnum {
  PA = 'PA',
  SS = 'SS',
  SAS = 'SAS',
  SNC = 'SNC',
  STP = 'STP',
  SRL = 'SRL',
  SAPA = 'SAPA',
  SPA = 'SPA',
  FON = 'FON',
  COOP = 'COOP',
  CONS = 'CONS',
  ASSO = 'ASSO',
  FOUN = 'FOUN',
  FOUNB = 'FOUNB',
  SA = 'SA',
  TRU = 'TRU',
  ALTRO = 'ALTRO',
}
